<form [formGroup]="form">
  <love-it-modal-header
    (close)="modal.dismiss()"
    title="Berichtszeitraum auswählen"></love-it-modal-header>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12">
          <label
            for="range"
            class="required-label"
            >Zeitraum</label
          >
          <love-it-date-range-picker
            id="range"
            formControlName="range"
            [required]="true"
            [clearable]="false"
            [ngClass]="{
              'is-invalid': form.get('range')?.errors,
            }"></love-it-date-range-picker>
          @if (form.get("range")?.errors) {
            <div class="invalid-feedback">
              @if (form.get("range")?.errors?.["required"]) {
                <div>Zeitraum ist ein Pflichtfeld.</div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      rippleEffect
      type="button"
      class="btn-mobile-group btn-primary"
      (click)="modal.close(form.value)">
      OK
    </button>
    <button
      rippleEffect
      type="button"
      class="btn-mobile-group btn-outline-secondary"
      (click)="modal.dismiss()">
      {{ form.dirty ? "Abbrechen" : "Zurück" }}
    </button>
  </div>
</form>
